module.exports = __webpack_public_path__ + "img/in-screen-side.c1af1a7e.png";